import { render, staticRenderFns } from "./Tipificacion.vue?vue&type=template&id=f1fdfa20&"
import script from "./Tipificacion.vue?vue&type=script&lang=js&"
export * from "./Tipificacion.vue?vue&type=script&lang=js&"
import style0 from "./Tipificacion.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports